// removed by extract-text-webpack-plugin
module.exports = {"box":"_32TpsPXSyMXrVnZ3oxvxDt"};


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/atoms/BoxShadow/style.css
// module id = 492
// module chunks = 38